import React, {ReactNode} from 'react';
import {Form, useFormikContext} from 'formik';

import Title from 'src/components/AccountSettings/Title';
import RequiredLegend from 'shared/components/required-legend';
import Button from 'src/components/button';
import styles from './form-container.module.scss';

export function AccountSettingsFormContainer(props: {
  title: string;
  hideRequiredLegend?: boolean;
  children: ReactNode;
}) {
  const {isSubmitting, isValid} = useFormikContext();

  return (
    <Form className={styles.form}>
      <Title>{props.title}</Title>
      {!props.hideRequiredLegend && <RequiredLegend />}
      {props.children}
      <div className={styles.button}>
        <Button color="primary" type="submit" disabled={isSubmitting || !isValid} margin={false}>
          {isSubmitting ? 'Saving...' : 'Save Changes'}
        </Button>
      </div>
    </Form>
  );
}
